export const formatPermissionLabel = (permission: string) => {
  switch (permission) {
    case 'tigertouchplus_reporting':
      return 'Patient Reporting';
    case 'contact_center_operator':
      return 'Operator';
    case 'contact_center_operator_supervisor':
      return 'Operator Supervisor';
    case 'clinical_workflow':
      return 'Clinical Workflow';
    case 'clinical_workflow_chat':
      return 'Clinical Workflow Chat';
    case 'clinical_workflow_insights':
      return 'Clinical Workflow Insights';
    case 'tiger_agent':
      return 'Ask Tiger';
    default:
      return permission.replaceAll('_', ' ').replaceAll('scim', 'SCIM');
  }
};
